import React from 'react';
import PropTypes from 'prop-types';

import Box from '../../shared/Box';
import Pressable from '../../shared/Pressable';
import { OutsideClickContainer } from '../OutsideClickContainer';
import { FlyoutMenu } from '../FlyoutMenu';

const DropdownMenu = ({
  toggleMenuVisibility,
  isMenuVisible,
  renderPressableContent,
  menuItems,
  renderMenuHeader,
  renderMenuFooter,
}) => (
  <Box
    display="flex"
    alignItems="center"
    dangerouslySetInlineStyle={{ flex: 1 }}
  >
    <Pressable onPress={toggleMenuVisibility}>
      {() => renderPressableContent}
    </Pressable>
    {isMenuVisible && (
      <OutsideClickContainer onClickOutside={toggleMenuVisibility}>
        <FlyoutMenu
          renderHeader={renderMenuHeader}
          renderFooter={renderMenuFooter}
          menuItems={menuItems}
          onClickMenuItem={toggleMenuVisibility}
        />
      </OutsideClickContainer>
    )}
  </Box>
);

DropdownMenu.defaultProps = {
  renderMenuHeader: null,
  renderMenuFooter: null,
};

DropdownMenu.propTypes = {
  toggleMenuVisibility: PropTypes.bool.isRequired,
  isMenuVisible: PropTypes.bool.isRequired,
  renderPressableContent: PropTypes.element.isRequired,
  renderMenuHeader: PropTypes.element,
  renderMenuFooter: PropTypes.element,
  menuItems: PropTypes.element.isRequired,
};

export { DropdownMenu };
